/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/router/hospitalBookingRoutes.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Wednesday, March 13th 2024, 12:43:36 pm                        *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */

const hospitalRoutes = [
    {
        path: '/opd',
        name: 'OPDHome',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDBookingPages/mainPages/hospitalHomePage.vue')
    },
    {
        path: '/viewHospital/:hospitalRegNumber',
        name: 'ViewHospital',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDBookingPages/mainPages/viewHospitalPage.vue')
    },
    {
        path: '/opd/bookingDetails/:bookingID',
        name: 'hospitalBookingSuccess',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDBookingPages/mainPages/bookingSuccessPage.vue')
    },
    {
        path: '/package/bookingDetails/',
        name: 'hospitalPackageBookingSuccess',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/bookingSuccessPackagePage.vue')
    },
    {
        path: '/opdAppointments',
        name: 'listOPDAppointmentsPage',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDBookingPages/mainPages/listOPDAppointmentsPage.vue')
    },
    {
        path: '/packageAppointments',
        name: 'ListPackageAppointments',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/OPDPackageListAppointments.vue')
    },
    {
        path: '/opdAppointmentDetail/:bookingID',
        name: 'particularOPDAppointment',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDBookingPages/mainPages/particularOPDAppointment.vue')
    },
    {
        path: '/packageAppointmentDetail/:bookingID',
        name: 'particularPackageAppointment',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/particularOPDPackageAppointment.vue')
    },
    {
        path: '/opdpackage',
        name: 'OPDPackageHome',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/OPDPackageHomePage.vue')
    },
    {
        path: '/package/viewHospital/:hospitalRegNumber',
        name: 'OPDPackageViewHospital',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/OPDPackageViewHospitalPage.vue')
    },
    {
        path: '/packagedetail/:packageID',
        name: 'OPDPackageDetails',
        visibility: false,
        authentication: true,
        component: () => import('../views/OPDPackagePages/mainPages/OPDPackageDetails.vue')
    },
    {
        path : '/packagepayment/QRcode',
        name : 'PackageQRCode',
        visibility: false,
        authentication: true,
        component: () => import ('../views/OPDPackagePages/componentsUsedInPages/OPDPackageDetails/QRPackagePage.vue')
      },
]
module.exports = {
    hospitalRoutes
}